import { toast } from 'sonner'

/**
 * Holt aus den Fehlerobjekten, die hier vorkommen, eine lesbare Meldung heraus:
 * ApolloError (graphQLErrors, networkError), Nhost-Antworten ({ error, message }),
 * Listen von GraphQL-Fehlern, einfache Error-Objekte und Strings. null, wenn nichts
 * Brauchbares drinsteht.
 */
export function describeError(error: unknown): string | null {
  if (!error) return null
  if (typeof error === 'string') return error.trim() || null
  if (Array.isArray(error)) {
    const parts = error.map(describeError).filter((part): part is string => !!part)
    return parts.length > 0 ? Array.from(new Set(parts)).join(', ') : null
  }
  if (typeof error === 'object') {
    const e = error as Record<string, unknown>
    if (Array.isArray(e.graphQLErrors) && e.graphQLErrors.length > 0) {
      const fromGraphql = describeError(e.graphQLErrors)
      if (fromGraphql) return fromGraphql
    }
    if (e.networkError) {
      const fromNetwork = describeError(e.networkError)
      if (fromNetwork) return fromNetwork
    }
    if (typeof e.message === 'string' && e.message.trim()) return e.message.trim()
    if (e.error && e.error !== error) return describeError(e.error)
  }
  return null
}

/**
 * Zeigt der Nutzerin einen Fehler als Toast: die eigene Beschreibung des Vorgangs,
 * ergänzt um die Serverantwort, wenn es eine gibt. Ersetzt alert() und stille
 * console.error-Aufrufe.
 *
 *   notifyError(error, 'Fehler beim Speichern')
 */
export function notifyError(error: unknown, fallback: string): void {
  const detail = describeError(error)
  toast.error(detail && detail !== fallback ? `${fallback}: ${detail}` : fallback)
}
